//------------ REACT IMPORT --------------//
import React, { useEffect } from "react";
//--------- FONTAWESOME IMPORTS ----------//
import { faArrowLeft, faChevronRight, faPlus, faUserPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//--------- IMAGES IMPORTS ----------//
import { Menu, NotificationBell, Search } from "../../assets/images";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Image } from "react-bootstrap";
import AuthController from "../../apis/Controllers/AuthController/AuthController";
import { setUserData } from "../../redux/actions/users";
import store from "../../redux/store";
import { useNavigate } from "react-router-dom";


const WithoutImageHeader = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
        getUserData();
    }, []);


    const getUserData = async () => {
        window.scrollTo(0, 0);
        let item = localStorage.getItem('SET_USER_DATA');
        item = JSON.parse(item);
        let user = item;
        if (user) {
            if (user && user.access && user.access.token) {
                await store.dispatch(setUserData(user));
            }
        }
        else {
            logout();
        }
    };


    const logout = async () => {
        store.dispatch(setUserData({}));
        localStorage.clear();
        navigate("/login");
    };

    return (
        <div className="without_image_header">
            <div className="header_area">
                <div className="details">
                    {props.lefticon === 'menu' ?
                        <div className="menu_icon">
                            <div className="img_menu">
                                <Image src={Menu} alt="..." />
                            </div>
                        </div>
                        :
                        <FontAwesomeIcon icon={faArrowLeft} className="arrow" />}
                    <h3>{props.header}</h3>
                    {props.icon === "edit" ?
                        <div className="icon_user" onClick={() => props && props.handleNavigate ? props.handleNavigate() : ''}>
                            <FontAwesomeIcon icon={faUserPen} />
                        </div>
                        :
                        props.icon === "notification" ?
                            <div className="search_area">
                                <div className="img_search">
                                    <Image src={NotificationBell} alt="..." />
                                </div>
                            </div>
                            :
                            props.icon === "add" ?
                                <div className="add_area">
                                    <a href="javascript:;"><FontAwesomeIcon icon={faPlus} className="add_icon" />Add</a>
                                </div>
                                :
                                <div className="icon_area">
                                    <div className="img_one">
                                        <Image src={Search} alt="..." />
                                    </div>
                                    <div className="img_two">
                                        <Image src={NotificationBell} alt="..." />
                                    </div>
                                </div>}
                </div>
                <div className="breadcrum_area">

                    {props.breadcrumData ? props.breadcrumData.map((item, i) =>
                        <div>
                            <a href="#javscript:;" >{item}</a><FontAwesomeIcon icon={faChevronRight} className="icon" />
                        </div>
                    ) : null}

                    <span>{props.breadcrumItem}</span>
                </div>
            </div>
        </div>
    )
}

export default WithoutImageHeader;